var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left-header"},[_c('logo'),_c('span',{staticStyle:{"color":"#fff"}},[_vm._v(_vm._s(_vm.$store.state.systemConfig.currentVersion))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }